import React from "react";

import { Ghost } from "lucide-react";

/**
 * Standard empty state component for when no data is available.
 * @param {React.ComponentType} icon - The icon component to display
 * @param {string} title - The primary empty state message
 * @param {string} description - Supporting text or call to action
 */
const EmptyState = ({
  icon: Icon = Ghost,
  title = "No data found",
  description = "There are no items to display at this time."
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="relative mb-6">
        <div className="absolute inset-0 bg-gradient-to-tr from-yale-blue-100 to-atomic-tangerine-100 dark:from-yale-blue-800/30 dark:to-atomic-tangerine-900/20 rounded-full blur-2xl opacity-60 animate-pulse" />
        <div className="relative bg-white dark:bg-yale-blue-800 w-24 h-24 rounded-2xl flex items-center justify-center shadow-xl border border-slate-100 dark:border-yale-blue-700 transform rotate-3 hover:rotate-0 transition-transform duration-300">
          <Icon className="w-12 h-12 text-yale-blue-400 dark:text-yale-blue-300" />
        </div>
      </div>
      <h3 className="text-xl font-bold text-yale-blue-900 dark:text-slate-100 tracking-tight">{title}</h3>
      {description && (
        <p className="text-slate-500 dark:text-slate-400 mt-3 max-w-xs mx-auto text-sm leading-relaxed">{description}</p>
      )}
    </div>
  );
};

export default EmptyState;
